export default __webpack_public_path__ + "static/media/github.e8efa7f4.png";